import { Link } from "react-router-dom";

interface BreadcrumbProps {
  items: { label: string; to?: string }[];
  tone?: "default" | "onDark";
}

export default function Breadcrumb({ items, tone = "default" }: BreadcrumbProps) {
  const muted = tone === "onDark" ? "text-background-300" : "text-foreground-500";
  const current = tone === "onDark" ? "text-background-50" : "text-foreground-800";
  const hover = tone === "onDark" ? "hover:text-accent-300" : "hover:text-accent-600";

  return (
    <nav aria-label="面包屑导航" className={`flex items-center flex-wrap gap-1.5 text-xs ${muted}`}>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5 min-w-0">
          {index > 0 && <i className={`ri-arrow-right-s-line leading-none ${tone === "onDark" ? "text-background-400" : "text-foreground-400"}`} />}
          {item.to ? (
            <Link to={item.to} className={`transition-colors whitespace-nowrap ${hover}`}>
              {item.label}
            </Link>
          ) : (
            <span className={`${current} truncate max-w-[220px] md:max-w-none`}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}